
const ContactInfo = () => {
  const contactMethods = [
    {
      icon: 'ri-phone-line',
      title: 'Phone',
      details: ['+1 (825) 288-2472', '+1 (519) 991-0575', '+1 (403) 998-6339'],
      description: 'Monday - Friday: 9:00 AM - 6:00 PM\nSaturday: 10:00 AM - 4:00 PM',
      color: 'bg-blue-50 text-blue-600'
    },
    {
      icon: 'ri-mail-line',
      title: 'Email',
      details: ['info@landmarkcooperative.ca'],
      description: 'We respond to all emails within 24 hours',
      color: 'bg-green-50 text-green-600'
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Address',
      details: ['Coming Soon'],
      description: 'Our physical office location will be announced shortly',
      color: 'bg-purple-50 text-purple-600'
    },
    {
      icon: 'ri-time-line',
      title: 'Business Hours',
      details: ['Coming Soon'],
      description: 'Our business hours will be announced shortly',
      color: 'bg-orange-50 text-orange-600'
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Get in Touch
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Multiple ways to reach us and get the support you need
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {contactMethods.map((method, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg p-6 text-center">
              <div className={`w-12 h-12 ${method.color} rounded-lg flex items-center justify-center mx-auto mb-4`}>
                <i className={`${method.icon} text-xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{method.title}</h3>
              <div className="space-y-1 mb-3">
                {method.details.map((detail, detailIndex) => (
                  <p key={detailIndex} className="text-gray-900 font-medium">{detail}</p>
                ))}
              </div>
              <p className="text-gray-600 text-sm whitespace-pre-line">{method.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ContactInfo;
